import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import { loadBreakingNewsData } from './redux';
import BreakingNews from '../../components/BreakingNews';

class WithBreakingNews extends React.Component {
  constructor() {
    super();
    this.state = {
      hideWidget: false,
    };
  }
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({})),
    loadData: PropTypes.func,
    theme: PropTypes.string,
    // eslint-disable-next-line react/no-typos
    customComponent: PropTypes.func,
    addWrapper: PropTypes.bool,
    withClose: PropTypes.bool,
    isMobile: PropTypes.bool,
  };
  static defaultProps = {
    data: undefined,
    loadData: undefined,
    theme: undefined,
    customComponent: undefined,
    addWrapper: false,
    withClose: false,
    isMobile: false,
  };

  LoadBreakingNewsData = params => {
    this.props.loadData(params);
  };
  closeWidget = () => {
    if (window.sessionStorage) {
      sessionStorage.setItem('brknewsClose', '1');
    }
    this.setState({
      hideWidget: true,
    });
    sendGaThroughProps({
      data: {
        gaCategory: 'ATF_breaking_news_bar',
        gaAction: 'close_icon',
        gaLabel: '',
      },
    });
  };
  componentDidMount() {
    const params = {
      isTest:
        typeof window !== 'undefined' &&
        window.location.search.includes('brknewstest'),
    };
    const brknewsCloseExist = window.sessionStorage
      ? sessionStorage.getItem('brknewsClose') !== '1'
      : true;
    if (brknewsCloseExist) {
      this.LoadBreakingNewsData(params);
    }
  }
  render() {
    const { data, customComponent: MyComponent } = this.props;
    if (data && !this.state.hideWidget) {
      if (MyComponent) {
        return (
          <MyComponent data={this.props.data} closeWidget={this.closeWidget} />
        );
      }
      return (
        <BreakingNews
          data={this.props.data}
          theme={this.props.theme}
          addWrapper={this.props.addWrapper}
          withClose={this.props.withClose}
          closeWidget={this.closeWidget}
          isMobile={this.props.isMobile}
        />
      );
    }
    return null;
  }
}

const mapStateToProps = state => ({
  data: state.breakingNews.data,
  isMobile: state.isMobile,
});

const mapDispatchToProps = dispatch => ({
  loadData: params => {
    dispatch(loadBreakingNewsData(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(WithBreakingNews);
